import { useNavigate } from 'react-router';

import { Button } from '@/shared/ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <main className="grid min-h-dvh place-items-center bg-surface-backdrop px-6 text-center">
      <div>
        <h1 className="text-xl font-bold text-content-primary">That screen does not exist</h1>
        <p className="mx-auto mt-3 max-w-[34ch] text-sm text-content-secondary">
          The link may be out of date. Everything the till does is reachable from the bar at the
          bottom.
        </p>
        <Button className="mt-6" onClick={() => void navigate('/sell', { replace: true })}>
          Go to the sale screen
        </Button>
      </div>
    </main>
  );
}
